/* These functions make sure WordPress and Foundation play nice together.*/
jQuery(document).ready(function() {
	widgetSlider();
	siteJsEssentials();
	initParallax();
	initScroller();
	initPreloaderScreen();
	speciatySlides();
	locationSlides();
	fpSlider();
	//fmDebugr();
	//coolColorOverLay();
	//initHpVideo();
	//checkVideo();
	//formLabel2Placeholder();
	//cf7fix();
	// lets update the specialtySlides(); function to work with the Services Tabbed 	content area on the home page	
});

function fmDebugr() {
	var currentBreakpoint = Foundation.MediaQuery.current;
	console.log('the current breakpoint is ' + currentBreakpoint);
	jQuery(window).resize(function() {
		//new Foundation.Equalizer(jQuery(".outerOdd, .outerEven")).applyHeight();
		var currentBreakpoint = Foundation.MediaQuery.current;
		console.log('the current breakpoint is ' + currentBreakpoint);
	});
}

function fpSlider(){
	var fbSlider = jQuery('#fp-banner.fpBannerSlider');
	fbSlider.flickity({
		cellAlign: 'left',
		contain: true,
		autoPlay: false,
		wrapAround: true,
		pageDots: true,
		prevNextButtons: false,
		imagesLoaded: true,
		cellSelector: ".fp-banner-bg",	
	});
	var leftDots = jQuery('#fp-banner.fpBannerSlider .flickity-page-dots');
	leftDots.wrap('<div id="leftDotsWrap"><div class="row dots-row column text-left"></div></div>');
	
	leftDots.prepend('<li class="inline-block"><a class="prevArrow"><i class="fa fa-angle-left" aria-hidden="true"></i></a></li>');
	leftDots.append('<li class="inline-block"><a class="nextArrow"><i class="fa fa-angle-right" aria-hidden="true"></i></a></li>');
	
	jQuery('.prevArrow').on( 'click', function() {
		fbSlider.flickity( 'previous' );
	});	
	jQuery('.nextArrow').on( 'click', function() {
		fbSlider.flickity( 'next' );
	});		
}

function speciatySlides() {
	var fmitem = "";
	var fmitemtarget = "";
	var $serviceFlickity = jQuery('#serviceInnerSlider-1');
	jQuery(".fm-item").each(function() {
		fmitem = jQuery(this).attr("data-fm-item");
		jQuery(this).addClass('fm-item-' + fmitem);
	});
	jQuery('.fm-item-target.active').addClass('fadeIn');
	jQuery(".fm-item-target").each(function() {
		fmitemtarget = jQuery(this).attr("data-fm-item-target");
		jQuery(this).addClass('fm-item-target-' + fmitemtarget + ' animate');
	});

	// initial flickity init when the page loads
	$serviceFlickity.flickity({
		// options
		cellAlign: 'left',
		contain: true,
		autoPlay: false,
		wrapAround: true,
		pageDots: false,
		prevNextButtons: true,
		imagesLoaded: true,
		cellSelector: ".serviceInnerSlide",
		groupCells: '100%',
	});
	
	// attach custom next/previous buttons to control the current visible slider
	jQuery('.prevSlide').on( 'click', function() {
		$serviceFlickity.flickity( 'previous' );
	});	
	jQuery('.nextSlide').on( 'click', function() {
		$serviceFlickity.flickity( 'next' );
	});		
	
	// create select field controls for mobile screens for category selector
	var $serviceSelect = jQuery('select.serviceCatSelect');
	var $serviceSelectData = 1;
	$serviceSelect.change(function() {
		fmitem = jQuery(this).attr("data-fm-item");
		$serviceSelectData = $serviceSelect.val();
		jQuery(this).addClass('active');
		$serviceFlickity = jQuery('#serviceInnerSlider-' + $serviceSelectData);
		jQuery('.fm-item-target-' + $serviceSelectData).removeClass('inactive fadeOut');
		for (var ctr = 1; ctr <= 4; ctr++) {
			if ($serviceSelectData != ctr) {
				jQuery('.fm-item-' + ctr).removeClass('active');
				jQuery(".fm-item-target-" + ctr).removeClass('active fadeIn').addClass('inactive fadeOut');
				jQuery('#serviceInnerSlider-' + ctr).flickity().flickity('destroy');
			}
		}
		
		jQuery('#serviceInnerSlider-' + $serviceSelectData).flickity({
			// options
			cellAlign: 'left',
			contain: true,
			autoPlay: false,
			wrapAround: true,
			pageDots: false,
			prevNextButtons: true,
			imagesLoaded: true,
			cellSelector: ".serviceInnerSlide",
			groupCells: '100%',
		});
		jQuery('.fm-item-target-' + $serviceSelectData).addClass('active fadeIn');	
		
	});

	// Set up click events for category slider sector
	jQuery(".fm-item").click(function() {
		fmitem = jQuery(this).attr("data-fm-item");
		jQuery('select.serviceCatSelect [value="'+fmitem+'"]').attr('selected',true);
		jQuery(this).addClass('active');
		$serviceFlickity = jQuery('#serviceInnerSlider-' + fmitem);
		jQuery('.fm-item-target-' + fmitem).removeClass('inactive fadeOut');
		for (var ctr = 1; ctr <= 4; ctr++) {
			if (fmitem != ctr) {
				jQuery('.fm-item-' + ctr).removeClass('active');
				jQuery(".fm-item-target-" + ctr).removeClass('active fadeIn').addClass('inactive fadeOut');
				jQuery('#serviceInnerSlider-' + ctr).flickity().flickity('destroy');
			}
		}
		
		jQuery('#serviceInnerSlider-' + fmitem).flickity({
			// options
			cellAlign: 'left',
			contain: true,
			autoPlay: false,
			wrapAround: true,
			pageDots: false,
			prevNextButtons: true,
			imagesLoaded: true,
			cellSelector: ".serviceInnerSlide",
			groupCells: '100%',
		});
		jQuery('.fm-item-target-' + fmitem).addClass('active fadeIn');
		
	});

}

function locationSlides() {

	jQuery('.locationsSlider').flickity({
		cellAlign: 'center',
		contain: true,
		// autoPlay: 5000,
		autoPlay: false,
		wrapAround: true,
		pageDots: true,
		prevNextButtons: false,
		imagesLoaded: true,
		cellSelector: ".locationSlide",
		selectedAttraction: 0.01,
		friction: 0.25,		
	});

}

jQuery(window).resize(function() {
	navCheck();
});
jQuery(window).scroll(function() {
	navCheck();
	jQuery('.fadeInBlock').each(function(i) {
		var bottom_of_object = jQuery(this).position().top + jQuery(this).outerHeight();
		var bottom_of_window = jQuery(window).scrollTop() + jQuery(window).height(); /* Adjust the "200" to either have a delay or that the content starts fading a bit before you reach it  */
		bottom_of_window = bottom_of_window + 500;
		if (bottom_of_window > bottom_of_object) {
			jQuery(this).animate({
				'opacity': '1'
			}, 800);
		}
	});
});

jQuery(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
	// newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
});

function initPreloaderScreen() {
	setTimeout(function() {
		jQuery('.home #loader').addClass('animate zoomOut');
	}, 800);
	setTimeout(function() {
		jQuery('.home #loader-wrapper').fadeOut('slow');
		jQuery('.home .off-canvas-wrapper').css('opacity', 1);
	}, 1200);
	var fpBannerLogo = jQuery('.slide-logo');
	var fpButton = jQuery('.fp-banner-link');
	var fpfixedlogo = jQuery('.box .button');
	if (fpBannerLogo) {
		fpBannerLogo.css('opacity', 0);
		setTimeout(function() {
			fpBannerLogo.css('opacity', 1);
			fpBannerLogo.addClass('animate zoomIn');
		}, 1400);
	}
/*
	if (fpfixedlogo) {
		setTimeout(function() {
			fpfixedlogo.addClass('animate fadeIn');
		}, 1400);
	}
*/
	if (fpButton) {
		fpButton.css('opacity', 0);
		setTimeout(function() {
			fpButton.css('opacity', 1);
			fpButton.addClass('animate fadeIn');
		}, 1300);
	}
	initSubmenus();
}

function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity', 1);
/*
	if (jQuery('body').hasClass('home')) {
		setTimeout(function() {
			jQuery('.home .head-bar .fixedlogo').css('display', 'none').addClass('animate fadeInLeft');
		}, 800);
	} else {
		setTimeout(function() {
			jQuery('.head-bar .fixedlogo').css('display', 'block').addClass('animate fadeInLeft');
		}, 800);
	}
*/
}
// dont forget to put the CSS
// form.form label { display: none; }
//

function formLabel2Placeholder() {
	jQuery("form :input").each(function(index, elem) {
		var eId = jQuery(elem).attr("id");
		var label = null;
		if (eId && (label = jQuery(elem).parents("form").find("label[for=" + eId + "]")).length == 1) {
			jQuery(elem).attr("placeholder", jQuery(label).html());
			jQuery(label).remove();
		}
	});
}

function cf7fix() {
	jQuery('input.wpcf7-submit').click(function() {
		setTimeout(function() {
			jQuery('input.wpcf7-submit').attr('disabled', 'disabled');
		}, 100);
	});
	jQuery(".wpcf7").on('wpcf7:submit', function(event) {
		jQuery(this).find('input.wpcf7-submit').removeAttr('disabled');
	});
}
// CHECKS FOR STATIC / FIXED NAVIGATION

function navCheck() {
	var isDesktop = jQuery(document).width() > 1000 ? true : false;
	// If document (your website) is wider than 1023px, notVisible = true, else notVisible = false
	if (!isDesktop) {
		jQuery('#menu-bar-wrapper').removeClass('swipeup');
		jQuery('#menu-bar-wrapper').removeClass('fixed');
	} else {
		desktopNavToggle();
	}
}
var toggler = false;
var previousScroll = 0;

function desktopNavToggle() {
	var offset = jQuery('#menu-bar-wrapper').offset();
	if (offset) {
		var height = jQuery(window).scrollTop();
		var currentScroll = jQuery(window).scrollTop();
		if (currentScroll < previousScroll && toggler === true && height < 95 && offset.top < 145) {
			jQuery('.home #menu-bar-wrapper').addClass('swipeup');
			toggler = false;
		}
		previousScroll = currentScroll;
		if (height < 89 && offset.top < 140) {
			toggler = false;
		} else {
			toggler = true;
			jQuery('.home #menu-bar-wrapper').addClass('fixed');
			jQuery('.home #menu-bar-wrapper').removeClass('swipeup');
			jQuery('.home .head-bar .fixedlogo').css('display', 'block');
		}
		if (currentScroll < 30) {
			jQuery('.home #menu-bar-wrapper').removeClass('swipeup');
			jQuery('.home #menu-bar-wrapper').removeClass('fixed');
			jQuery('.home .head-bar .fixedlogo').css('display', 'none');
		}
	}
}
// CUSTOM SLIDER WIDGET SCRIPT

function widgetSlider() {
	jQuery('.sbReviewsSlider').flickity({
		// options
		cellAlign: 'left',
		contain: true,
		autoPlay: 3500,
		wrapAround: true,
		pageDots: false,
		prevNextButtons: false,
		imagesLoaded: true,
		cellSelector: ".wSlide",
		arrowShape: {
			x0: 10,
			x1: 70,
			y1: 40,
			x2: 70,
			y2: 40,
			x3: 70
		}
	});
}

function initParallax() {
	// use data-fptop to set the default starting point of the bg image
	// eg. <div data-fptop="100" style="background-image:url('somebg.jpg')></div>
	var parallax = document.querySelectorAll(".fpparallax"),
		speed = 0.4;
	window.onscroll = function() {
		[].slice.call(parallax).forEach(function(el, i) {
			var w = window.innerWidth;
			var mediaQueryVal = "";
			var ParaOffset = el.offsetTop;
			if (el.getAttribute('data-speed')) {
				speed = el.getAttribute('data-speed');
			}
			if (w > 1024) {
				mediaQueryVal = el.getAttribute('data-fp-large');
			} else if (w > 1024) {
				mediaQueryVal = el.getAttribute('data-fp-xmedium');
			} else if (w <= 1024 && w > 768) {
				mediaQueryVal = el.getAttribute('data-fp-medium');
			} else if (w <= 768 && w > 667) {
				mediaQueryVal = el.getAttribute('data-fp-small');
			} else if (w <= 667) {
				mediaQueryVal = el.getAttribute('data-fp-xsmall');
			}
			var windowYOffset = window.pageYOffset,
				minusTop = mediaQueryVal,
				//  elBackgrounPosVanilla = "50% " + (windowYOffset * speed) + "px";
				elBackgrounPos = "50% " + (((windowYOffset - ParaOffset) * speed) - minusTop) + "px";
			el.style.backgroundPosition = elBackgrounPos;
		});
	};
}

function siteJsEssentials() {
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();
	// Makes sure last grid item floats left
	jQuery('.archive-grid .columns').last().addClass('end');
	// Emma Form Tracking
	jQuery('#emma-form-submit').addClass('emmaTrackingLink');
	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').wrap("<div class='responsive-embed widescreen'/>");
	//console.log('hello dev team!');
	jQuery('.menu-bar-wrapper .top-bar .desktop-menu ul.menu li.menu-item ul.submenu li a').on("hover", function() {
		jQuery(this).parent().siblings().find('a').toggleClass('fadedLink');
	});
}
// VIDEO FOR FRONT PAGE

function initHpVideo() {
	var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
	jQuery('.promo .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false;
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".promo").addClass("mobile");
			jQuery(".promo").removeClass("desktop");
		} else {
			jQuery(".promo").addClass("desktop");
		}
	});
}

function checkVideo() {
	var vid = document.getElementById("fpVideo");
	if (vid) {
		vid.onloadedmetadata = function() {
			jQuery('.loader').fadeOut('slow');
		};
	}
}

function initScroller() {
	jQuery('.scrollink').click(function() {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = jQuery(this.hash);
			target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				jQuery('html,body').animate({
					scrollTop: target.offset().top - 40
				}, 1000);
				return false;
			}
		}
	});
}
//  coolColorOverlay Hover box
//  this is dependent on /scss/sections/plugins/cool-color.scss (include it via style.scss)
/*
	- to add coolColorOverlay to and element in your templates add the class .coolColor
	the js will look for a link with a class of .button to act as the trigger that will fade the background color when hovered.

	- if you would like to fade out any child elements with the color add a class of .unThis to them.

	- Available data attributes for coolColorOverlay

	data-cool-this="1"
	this allows the color to fade away when we hover on the target button
	set value to 1 or true to enable and 0 or false to disable
	(by default this is disabled)

	data-image-src="url"
	(add this if you would like a background image)

	data-cool-color="primary"
	this chooses the overlay color. It pull directly from the foundation color pallet
	the default / fallback is primary
	you may also set it to: secondary, success, warning, alert, black or white

	data-cool-btn="primary"
	this sets the hover color of the target button (if not set it will fallback to the data-cool-color value)
	you may also set it to: secondary, success, warning, alert, black or white
*/
function coolColorOverLay() {
	jQuery(".coolColor").each(function() {
		var ccattr = jQuery(this).attr('data-cool-color');
		var bcattr = jQuery(this).attr('data-cool-btn');
		if (typeof ccattr !== typeof undefined && ccattr !== false && ccattr !== '') {
			ccattr = jQuery(this).attr('data-cool-color');
		} else {
			ccattr = 'primary';
		}
		if (typeof bcattr !== typeof undefined && bcattr !== false && bcattr !== '') {
			bcattr = jQuery(this).attr('data-cool-btn');
		} else {
			bcattr = ccattr;
		}
		jQuery(this).children().wrapAll("<div class='coolContent'></div>");
		jQuery(this).children().find('.button').addClass(bcattr);
		var bgattr = jQuery(this).attr('data-image-src');
		if (typeof bgattr !== typeof undefined && bgattr !== false) {
			jQuery(this).addClass(ccattr).css({
				'background': 'url(' + bgattr + ')',
				'background-repeat': 'no-repeat',
				'background-size': 'cover',
				'background-position': 'center top',
				'padding': '3rem 0 5rem',
			});
		} else {
			jQuery(this).css({
				'position': 'relative',
				'padding': '3rem 0 5rem',
			});
		}
		var coolthis = jQuery(this).attr('data-cool-this');
		if (typeof coolthis !== typeof undefined && coolthis !== false && (coolthis === 'true' || coolthis === '1') && (coolthis !== '' || coolthis !== 0 || coolthis !== 'false')) {
			jQuery(this).find('.button').hover(function() {
				jQuery(this).parents('.coolColor').toggleClass('unCoolThis');
			});
		} else {}
	});
}
/*
CSS Browser Selector v0.4.0 (Nov 02, 2010)
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
License: http://creativecommons.org/licenses/by/2.5/
Contributors: http://rafael.adm.br/css_browser_selector#contributors
*/
function css_browser_selector(u) {
	var ua = u.toLowerCase(),
		is = function(t) {
			return ua.indexOf(t) > -1;
		},
		g = 'gecko',
		w = 'webkit',
		s = 'safari',
		o = 'opera',
		m = 'mobile',
		h = document.documentElement,
		b = [(!(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua)) ? ('ie ie' + RegExp.$1) : is('firefox/2') ? g + ' ff2' : is('firefox/3.5') ? g + ' ff3 ff3_5' : is('firefox/3.6') ? g + ' ff3 ff3_6' : is('firefox/3') ? g + ' ff3' : is('gecko/') ? g : is('opera') ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 : (/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) : is('konqueror') ? 'konqueror' : is('blackberry') ? m + ' blackberry' : is('android') ? m + ' android' : is('chrome') ? w + ' chrome' : is('iron') ? w + ' iron' : is('applewebkit/') ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '') : is('mozilla/') ? g : '', is('j2me') ? m + ' j2me' : is('iphone') ? m + ' iphone' : is('ipod') ? m + ' ipod' : is('ipad') ? m + ' ipad' : is('mac') ? 'mac' : is('darwin') ? 'mac' : is('webtv') ? 'webtv' : is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') : is('freebsd') ? 'freebsd' : (is('x11') || is('linux')) ? 'linux' : '', 'js'];
	c = b.join(' ');
	h.className += ' ' + c;
	return c;
}
css_browser_selector(navigator.userAgent);
// Disable scroll zooming and bind back the click event
//effects iframed google maps  within div with a class of .map-container and with style="pointer-events: none;"
var onMapMouseleaveHandler = function(event) {
		var that = jQuery(this);
		that.on('click', onMapClickHandler);
		that.off('mouseleave', onMapMouseleaveHandler);
		that.find('iframe').css("pointer-events", "none");
	};
var onMapClickHandler = function(event) {
		var that = jQuery(this);
		// Disable the click handler until the user leaves the map area
		that.off('click', onMapClickHandler);
		// Enable scrolling zoom
		that.find('iframe').css("pointer-events", "auto");
		// Handle the mouse leave event
		that.on('mouseleave', onMapMouseleaveHandler);
	};
	// Enable map zooming with mouse scroll when the user clicks the map
	jQuery('.map-container').on('click', onMapClickHandler);
